import stateObject from './user-state';

export default {
  setUserData(state, payload) {
    state.loggedIn = payload.loggedIn;
    state.id = payload.id;
    state.email = payload.email;
    state.firstname = payload.firstname;
    state.surname = payload.surname;
    state.uk_based = payload.uk_based;
    state.gender = payload.gender;
    state.postcode = payload.postcode;
    state.jobRoles = payload.jobRoles;
    state.institution_start_year = payload.institution_start_year;

    state.competitions_subscription = payload.competitions_subscription;
    state.courses_subscription = payload.courses_subscription;
    state.jobs_subscription = payload.jobs_subscription;
    state.subscription_decision = payload.subscription_decision;

    // NEW - TODO add

    state.jobTypes = payload.jobTypes;
    state.fullname = payload.fullname;

    state.profile_completion = payload.profile_completion;

    state.re_auth_is_required = payload.re_auth_is_required;
    state.re_auth_last_done_at_utc = payload.re_auth_last_done_at_utc;
    state.re_auth_next_required_at_utc = payload.re_auth_next_required_at_utc;

    state.is_personalisation_enabled = payload.is_personalisation_enabled;

    state.isAdmin = payload.isAdmin;
    state.isEmailChangePending = payload.isEmailChangePending;
    state.isEmailChangeable = payload.isEmailChangeable;
    state.isPasswordChangeable = payload.isPasswordChangeable;

    state.ethnicity = payload.ethnicity;
    state.parent_profession = payload.parent_profession;
    state.free_school_means = payload.free_school_means;
  },

  updateUserData(state, payload) {
    Object.keys(payload).forEach((key) => {
      state[key] = payload[key];
    });
  },
  // TODO: no idea why this throws a lint error. - DL
  resetData(state) {
    state = stateObject(); // eslint-disable-line
  },
};
